import axios from 'axios';

const API = axios.create({
  //baseURL : 'https://dev.api-hams.i-screamreport.com'
});

export default API;
